'use client';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { isEmpty } from 'lodash';

import { CompletedIcon } from './CompletedIcon';
import { useGameFormProvider } from './GameFormProvider';

export const SettingsInputs = () => {
  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="flex flex-row text-base font-semibold">
        <SettingsOutlinedIcon className="pr-1" /> Settings
      </div>
      <GameNameInput />
      <div className="flex w-full flex-col items-center gap-3">
        <CopyrightCheckbox />
        <CommunityGuidelinesCheckbox />
      </div>
      <div className="flex w-full border-b border-secondary" />
      <PublicOrPrivateButtons />
    </div>
  );
};

const GameNameInput = () => {
  const { name, setName, loading } = useGameFormProvider();

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-row justify-between">
        <label htmlFor="game_name_input" className="mb-1 text-sm font-medium">
          Game name
        </label>
        <CompletedIcon completed={!isEmpty(name)} />
      </div>
      <input
        id="game_name_input"
        type="text"
        disabled={loading}
        placeholder="Game name"
        className="input input-md h-[44px] w-full rounded-md border border-[#D0D5DD] text-base focus:border-[#D6BBFB] focus:outline-none"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </div>
  );
};

const PublicOrPrivateButtons = () => {
  const { publicGame, setPublicGame } = useGameFormProvider();

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex w-full flex-row items-start justify-start gap-2">
        <input
          className="mt-1"
          type="radio"
          checked={!publicGame}
          onChange={() => setPublicGame(false)}
        />
        <div className="flex flex-col">
          <span className="text-sm font-medium">Unlisted game</span>
          <span className="text-sm text-[#B2ABBB]">
            Only people you share the link with will be able to play this game.
          </span>
        </div>
      </div>

      <div className="flex w-full flex-row items-start justify-start gap-2">
        <input
          className="mt-1"
          type="radio"
          checked={publicGame}
          onChange={() => setPublicGame(true)}
        />
        <div className="flex flex-col">
          <span className="text-sm font-medium">Public game</span>
          <span className="text-sm text-[#B2ABBB]">
            Everyone will be able to play this game.
          </span>
        </div>
      </div>
    </div>
  );
};

const CopyrightCheckbox = () => {
  const { acceptedCopyright, setAcceptedCopyright } = useGameFormProvider();

  return (
    <div className="flex w-full flex-row items-start justify-start gap-2">
      <input
        className="mt-1"
        type="checkbox"
        checked={acceptedCopyright}
        onChange={(e) => setAcceptedCopyright(e.target.checked)}
      />
      <div className="flex flex-col">
        <span className="text-sm font-medium">
          I am the copyright owner of the images.
        </span>
        <span className="text-xs text-[#B2ABBB]">
          By checking this box, you confirm that you either own the copyright of
          the images you are uploading, or you have the legal right to use them
          through a valid license or because they are in the public domain. This
          ensures that all images comply with intellectual property laws and
          respect the rights of creators.
        </span>
      </div>
    </div>
  );
};

const CommunityGuidelinesCheckbox = () => {
  const {
    acceptedCommunityGuidelines,
    setAcceptedCommunityGuidelines,
    setShowGuidelinesModal,
  } = useGameFormProvider();

  return (
    <div className="flex w-full flex-row items-start justify-start gap-2">
      <input
        className="mt-1"
        type="checkbox"
        checked={acceptedCommunityGuidelines}
        onChange={(e) => setAcceptedCommunityGuidelines(e.target.checked)}
      />
      <span className="text-sm font-medium">
        I confirm that I have read and agree to follow the{' '}
        <span
          onClick={() => setShowGuidelinesModal(true)}
          className="text-info-content underline hover:cursor-pointer"
        >
          Community Guidelines
        </span>
        .
      </span>
    </div>
  );
};
